import { useEffect } from 'react';
export const useOutsideClick = (refs, outsideClick) => {
    useEffect(() => {
        const handleOutsideClick = (event) => {
            const isOutsideClick = refs.every((ref) => ref.current && !ref.current.contains(event.target));
            if (isOutsideClick) {
                outsideClick();
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [outsideClick, refs]);
};
//# sourceMappingURL=use-outside-click.js.map